import classnames from 'classnames/bind';
import { memo } from 'react';
import { ButtonLink } from '@wildberries/ui-kit';
import styles from './index.module.scss';

type TProps = {
  title: string;
  customProps: { link: string };
};

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Instruction-item';

export const InstructionItem = memo(
  ({ title, customProps: { link } }: TProps) => {
    return (
      <div className={cn(BLOCK_NAME)}>
        <ButtonLink
          routeName={link}
          target="_blank"
          text={title}
          textColor="blue"
          variant="link-without-underline"
        />
      </div>
    );
  },
);
